const VEHICLE_FACT_LABELS = {
  auto: { en: "Automatic", es: "Automático", ru: "Автомат", fr: "Automatique", de: "Automatik", it: "Automatico", nl: "Automaat", pl: "Automatyczna" },
  automatic: { en: "Automatic", es: "Automático", ru: "Автомат", fr: "Automatique", de: "Automatik", it: "Automatico", nl: "Automaat", pl: "Automatyczna" },
  manual: { en: "Manual", es: "Manual", ru: "Механика", fr: "Manuelle", de: "Manuell", it: "Manuale", nl: "Handgeschakeld", pl: "Manualna" },
  petrol: { en: "Petrol", es: "Gasolina", ru: "Бензин", fr: "Essence", de: "Benzin", it: "Benzina", nl: "Benzine", pl: "Benzyna" },
  gasoline: { en: "Petrol", es: "Gasolina", ru: "Бензин", fr: "Essence", de: "Benzin", it: "Benzina", nl: "Benzine", pl: "Benzyna" },
  diesel: { en: "Diesel", es: "Diésel", ru: "Дизель", fr: "Diesel", de: "Diesel", it: "Diesel", nl: "Diesel", pl: "Diesel" },
  electric: { en: "Electric", es: "Eléctrico", ru: "Электро", fr: "Électrique", de: "Elektrisch", it: "Elettrica", nl: "Elektrisch", pl: "Elektryczny" },
  hybrid: { en: "Hybrid", es: "Híbrido", ru: "Гибрид", fr: "Hybride", de: "Hybrid", it: "Ibrida", nl: "Hybride", pl: "Hybrydowy" },
};

const VEHICLE_CATEGORY_LABELS = {
  "muscle-cars": { en: "American muscle cars", es: "Muscle cars americanos", ru: "Американские маслкары", fr: "Sportives américaines haute performance", de: "Amerikanische Muscle-Cars", it: "Muscle car americane", nl: "Amerikaanse muscle cars", pl: "Amerykańskie muscle cars" },
  "luxury-suv": { en: "Luxury SUVs", es: "SUV de lujo", ru: "Премиальные внедорожники", fr: "SUV de luxe", de: "Luxus-SUVs", it: "SUV di lusso", nl: "Luxe SUV’s", pl: "Luksusowe SUV-y" },
  "performance-gt": { en: "Performance grand touring", es: "Gran turismo de altas prestaciones", ru: "Высокопроизводительные гран-туризмо", fr: "Grand tourisme haute performance", de: "Hochleistungs-Gran-Turismo", it: "Gran turismo ad alte prestazioni", nl: "High-performance grand tourers", pl: "Sportowe gran turismo" },
};

const DAILY_RATE_COPY = {
  en: { from: "From", unit: "/ day" }, es: { from: "Desde", unit: "/ día" },
  ru: { from: "От", unit: "/ день" }, fr: { from: "À partir de", unit: "/ jour" },
  de: { from: "Ab", unit: "/ Tag" }, it: { from: "Da", unit: "/ giorno" },
  nl: { from: "Vanaf", unit: "/ dag" }, pl: { from: "Od", unit: "/ dzień" },
};

export function localizeVehicleCategory(key, lang) {
  const localized = VEHICLE_CATEGORY_LABELS[key];
  return localized ? (localized[lang] || localized.en) : String(key || "").replace(/-/g, " ");
}

export const dailyRateCopy = (lang) => DAILY_RATE_COPY[lang] || DAILY_RATE_COPY.en;

export function localizeVehicleFact(value, lang) {
  if (value === null || value === undefined) return "";
  const raw = String(value).trim();
  const localized = VEHICLE_FACT_LABELS[raw.toLowerCase()];
  return localized ? (localized[lang] || localized.en || raw) : raw;
}
